import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { checkout } from "../redux/actionCreators";
import LeadingText from "../LeadingText";
import SupportingText from "../SupportingText";
import FlatActionButton from "../FlatActionButton";
import Checkbox from "../Checkbox";
import { formatPrice } from "../helpers";

const sum = (a, b) => a + b;

const mapStateToProps = ({ cart, auth, checkout }) => ({
  cartQuantity: cart.cartItems.length,
  cart: cart.cartItems,
  cartTotal: cart.cartItems.map(el => el.price).reduce(sum, 0),
  client: auth.currentUser,
  checkoutStatus: checkout.checkoutStatus
});

const mapDispatchToProps = dispatch => ({
  checkout: (cart, client) =>
    dispatch(
      checkout({
        cart,
        client
      })
    )
});

function BillingHeader({ heading }) {
  return (
    <div className="w-full border-b border-grey-lighter py-1">
      <LeadingText
        textColor="black"
        textAlign="center"
        textSize="lg"
        fontWeight="medium"
      >
        {heading.toUpperCase()}
      </LeadingText>
    </div>
  );
}

function BillingRow({ attribute, subAttribute, value }) {
  return (
    <div className="w-100 flex flex-row justify-between">
      <div className="w-2/3">
        <SupportingText
          textColor="grey-darkest"
          textSize="lg"
          fontWeight="thin"
          textAlign="left"
        >
          {attribute}
        </SupportingText>
        {subAttribute ? (
          <div className="pt-1">
            <SupportingText
              textColor="grey-dark"
              textSize="xs"
              fontWeight="hairline"
              textAlign="left"
            >
              {subAttribute}
            </SupportingText>
          </div>
        ) : null}
      </div>
      {value ? (
        <div className="w-1/3">
          <SupportingText
            textColor="grey-darkest"
            textSize="lg"
            fontWeight="light"
            textAlign="right"
          >
            {value}
          </SupportingText>
        </div>
      ) : null}
    </div>
  );
}

function BillingBox({ children }) {
  return <div className="w-full flex-col justify-between p-3">{children}</div>;
}

class Checkout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasCheckedAGBs: false,
      showAGBError: false
    };
  }

  toggleAGBs = () => {
    const { hasCheckedAGBs } = this.state;
    this.setState({
      hasCheckedAGBs: !hasCheckedAGBs,
      showAGBError: false
    });
  };

  render() {
    const { hasCheckedAGBs, showAGBError } = this.state;
    const {
      cartQuantity,
      cartTotal,
      client,
      cart,
      checkout: checkoutRequest,
      checkoutStatus
    } = this.props;
    return (
      <div className="w-full h-full flex flex-col justify-between items-center py-3">
        <div
          style={{
            height: "70%"
          }}
          className="w-full flex flex-col items-center border-b-2 border-red-lightest bg-white shadow-blur-lg p-3 rounded-sm"
        >
          <div
            style={{
              height: "50%"
            }}
            className="w-full"
          >
            <BillingHeader heading="Ihre Bestellung" />
            <BillingBox>
              <div className="pb-3">
                <BillingRow
                  attribute="Anzahl der Fassungen"
                  value={cartQuantity}
                />
              </div>
              <BillingRow
                attribute="Gesamtbetrag"
                subAttribute="zzgl. Mehrwertsteuer, Verpackung und Versand"
                value={`${formatPrice(cartTotal)} €`}
              />
            </BillingBox>
          </div>
          <div
            style={{
              height: "50%"
            }}
            className="w-full"
          >
            <BillingHeader heading="Ihre Rechnungsadresse" />
            <BillingBox>
              {client &&
                Object.keys(client).map((attribute, index) => (
                  <BillingRow key={index} attribute={client[attribute]} />
                ))}
              <div className="pt-2">
                <SupportingText
                  textColor="grey-dark"
                  textSize="xs"
                  fontWeight="hairline"
                  textAlign="left"
                >
                  Die Versandadresse entspricht der Rechnungsadresse
                </SupportingText>
              </div>
            </BillingBox>
          </div>
        </div>
        <div
          style={{
            height: "10%"
          }}
          className="w-full flex justify-between items-start py-3"
        >
          <Checkbox
            checked={hasCheckedAGBs}
            textColor="black"
            textSize="base"
            size="6"
            onChange={this.toggleAGBs}
          />
          <SupportingText textColor="black" textSize="base">
            Mit Meiner Bestellung erkläre ich mich mit den{" "}
            <a
              className="no-underline text-red-light text-base"
              target="_blank"
              rel="noopener noreferrer"
              href="http://www.libuda-optik.de/sites/default/files/AGB_Libuda_Optic_World.pdf"
            >
              AGBs
            </a>{" "}
            der Libuda Optic World einverstanden
          </SupportingText>
        </div>
        <div
          style={{
            height: "20%"
          }}
          className="w-full py-3 flex flex-col items-center justify-center"
        >
          <FlatActionButton
            onClick={() => {
              if (!hasCheckedAGBs) {
                return this.setState({
                  showAGBError: true
                });
              }
              checkoutRequest(cart, client);
            }}
            inlineStyle={{
              width: "50%"
            }}
          >
            Bestellen
          </FlatActionButton>
          {showAGBError && (
            <div className="p-3">
              <LeadingText
                textColor="blue"
                textAlign="center"
                fontWeight="normal"
                textSize="base"
              >
                Bitte akzeptieren Sie unsere AGBs.
              </LeadingText>
            </div>
          )}
          {checkoutStatus.indication === "error" && (
            <div className="p-3">
              <LeadingText
                textColor="blue"
                textAlign="center"
                fontWeight="normal"
                textSize="base"
              >
                {checkoutStatus.error.message}
              </LeadingText>
            </div>
          )}
          {checkoutStatus.indication === "loaded" && (
            <Redirect to="/checkout/success" />
          )}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);



// WEBPACK FOOTER //
// ./src/Checkout/Checkout.js